import React, { useEffect, useState } from 'react'
import { Card, Table, Pagination, Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import { getAccountInfoAPI, getAccountBalanceListAPI } from '@/apis/user'
import { checkLogin } from '@/utils'

const { Column } = Table
export default function BalanceList() {
  const navigate = useNavigate()
  const [accountInfo, setAccountInfo] = useState({})
  const [listLoading, setListLoading] = useState(false) //  表格加载状态
  //  列表请求参数
  const [listQuery, setListQuery] = useState({
    pageInt: 1,
    pageSize: 10
  })
  const [total, setTotal] = useState(0) //  列表总数
  //  获取列表
  const [list, setList] = useState()

  const onChange = (page, pageSize) => {
    listQuery.pageInt = page
    listQuery.pageSize = pageSize
    setListQuery({
      ...listQuery,
      pageInt: page,
      pageSize: pageSize
    })
    fetchData()
  }

  //  获取列表
  const fetchData = async () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    setListLoading(true)
    const res = await getAccountBalanceListAPI(listQuery)
    if (res.success === true) {
      if (res.result.list) {
          console.log('111',accountInfo)
        res.result.list.forEach((item, index) => {
          item.key = index
          item.account = accountInfo.userId + ' ' + decodeURIComponent(accountInfo.userName)
        })
      }
      setList(res.result.list)
      setTotal(res.result.total)
      setListLoading(false)
    }
  }
  //  获取账号详情
  const getAccountInfo = async () => {
    const res = await getAccountInfoAPI()
    if (res.success === true) {
      setAccountInfo(res.result)
      console.log(res.result)
      fetchData()
    }
  }

  useEffect(() => {
    getAccountInfo()
  }, [])

  return (
    <div>
      <div className="pageTitle">账户收支明细</div>
      <Card className="card">
        <Table dataSource={list} loading={listLoading} pagination={false}>
          <Column
            title="账号"
            key="action"
            render={() => (
              <Space size="middle">
                {accountInfo.userName} {accountInfo.userId}
              </Space>
            )}
          />
          <Column title="类型" dataIndex="type" />
          <Column
            title="金额"
            key="action"
            render={(_, record) => (
              <Space size="middle">
                {record.balanceType === 1 ? <span className="green">+{record.fee}</span> : <span className="red">-{record.fee}</span>}
              </Space>
            )}
          />
          <Column title="余额" dataIndex="balance" />
          <Column title="备注" dataIndex="remark" />
          <Column title="时间" dataIndex="time" />
        </Table>
        <Pagination hideOnSinglePage defaultPageSize={20} showTotal={total => '共 ' + total + ' 条数据'} pageSize={listQuery.pageSize} pageSizeOptions={['10', '20', '30', '50', '100']} total={total} showSizeChanger showQuickJumper onChange={onChange} />
      </Card>
    </div>
  )
}
